export default class Hotspot {
  constructor(dto = {}) {
    Object.assign(this, dto);
  }

  view = "Hotspot";
  action = "Hotspot";

  getX() {
    this.right - 10;
  }

  getY() {
    this.bottom - 5;
  }
}
